<template>
  <div class="order-food-item-management">
    <div class="main">
      <div class="title_bar">
        <div class="left">
          <div class="title">
            {{ $t('OrderFoodItemManagement.MainTitle') }}
          </div>
          <div class="tip">
            {{ $t('OrderFoodItemManagement.MainTip') }}
          </div>
        </div>
      </div>
      <el-tabs
        v-model="activeTab"
        :before-leave="handleBeforeLeaveTab"
      >
        <!-- 類別列表 -->
        <el-tab-pane
          :label="$t('OrderFoodItemManagement.MenuManagement')"
          name="menu"
        >
          <ItemsManagementWrapper
            ref="menuManagementWrapperRef"
            :title="$t('OrderFoodItemManagement.MenuList')"
            :btn-text="$t('OrderFood.FoodCategory')"
            @create="$router.push({ name: 'orderFoodMenuEdit', params: { id: '0' } })"
            @sort-active="(val) => handleSortActive('menu', val)"
            @save-order="handleSaveOrder('menu')"
          >
            <ItemsListSortable ref="menuListSortableRef" class="order-food-item-management__sortable" @drag-end="(val) => handleDragEnd('menu', val)">
              <el-table ref="menuTableRef" :data="menuList" row-key="id" :tree-props="{children: 'unset'}">
                <el-table-column label="#" :width="menuTableColumnSetting[0].width" align="center">
                  <template slot-scope="scope">
                    <TableDragBtn :is-sorting="isMenuTableSortable" :handler-class="'drag-handle'" :index="scope.$index" />
                  </template>
                </el-table-column>
                <el-table-column v-if="!isMenuTableSortable" width="1" type="expand">
                  <template slot-scope="scope">
                    <div
                      v-for="(item, index) in scope.row.children"
                      :key="`id${scope.row.id}_${index}`"
                      class="order-food-item-management__expand-item"
                      :class="{ 'order-food-item-management__expand-item--disabled': item.isCheck === 0 }"
                      :style="{'padding-left': menuTableExpandColumnPaddingLeft + 'px'}"
                    >
                      <div :style="menuTableColumnSetting[2].expandItemStyle">
                        {{ item.name }}
                      </div>
                      <div :style="menuTableColumnSetting[3].expandItemStyle">
                        {{ item.isCheck === 1 ? $t('OrderFoodItemManagement.Enable') : $t('OrderFoodItemManagement.Disable') }}
                      </div>
                      <div :style="menuTableColumnSetting[4].expandItemStyle">
                        <span>{{ item.prices[0].unitPrice }}, </span>
                        <span>{{ item.prices[0].isCheck === 1 ? $t('OrderFoodItemManagement.Enable') : $t('OrderFoodItemManagement.Disable') }}</span>
                      </div>
                      <div :style="menuTableColumnSetting[5].expandItemStyle">
                        <span>{{ item.prices[1].unitPrice }}, </span>
                        <span>{{ item.prices[1].isCheck === 1 ? $t('OrderFoodItemManagement.Enable') : $t('OrderFoodItemManagement.Disable') }}</span>
                      </div>
                      <div :style="menuTableColumnSetting[6].expandItemStyle">
                        <span>{{ item.displaySpec }}</span>
                      </div>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('OrderFood.FoodCategory')" :width="menuTableColumnSetting[1].width" label-class-name="order-food-item-management__expand-column-title">
                  <template slot-scope="scope">
                    <TableExpandBtn :name="scope.row.name" :is-expand="scope.row.isExpand" :disabled="scope.row.children.length <= 0 || isMenuTableSortable" @icon-click="handleRowExpand('menu', scope.row)" />
                  </template>
                </el-table-column>
                <el-table-column :label="$t('OrderFood.FoodItem')" :width="menuTableColumnSetting[2].width">
                </el-table-column>
                <el-table-column :label="$t('OrderFoodItemManagement.Status')" :width="menuTableColumnSetting[3].width">
                  <template slot-scope="scope">
                    {{ scope.row.isCheck === 1 ? $t('OrderFoodItemManagement.Enable') : $t('OrderFoodItemManagement.Disable') }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('OrderFood.NormalPoints')" :width="menuTableColumnSetting[4].width">
                </el-table-column>
                <el-table-column :label="$t('OrderFood.CashPoints')" :width="menuTableColumnSetting[5].width">
                </el-table-column>
                <el-table-column :label="$t('OrderFood.SpecOptions')">
                </el-table-column>
                <el-table-column :label="$t('OrderFoodItemManagement.Action')" :width="menuTableColumnSetting[7].width">
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      plain
                      size="mini"
                      :disabled="isMenuTableSortable"
                      @click="$router.push({ name: 'orderFoodMenuEdit', params: { id: scope.row.id } })"
                    >
                      {{ $t('OrderFoodItemManagement.Edit') }}
                    </el-button>
                  </template>
                </el-table-column>
                <template slot="empty">
                  <div class="order-food-item-management__empty-container">
                    <span class="order-food-item-management__empty-text">
                      {{ $t('OrderFoodItemManagement.HaveNotCreatedAnyFoodCategory') }}
                    </span>
                    <span class="order-food-item-management__empty-text">
                      {{ $t('OrderFoodItemManagement.FoodCategoryTableCreateTip1') }}
                    </span>
                    <span class="order-food-item-management__empty-text">
                      {{ $t('OrderFoodItemManagement.FoodCategoryTableCreateTip2') }}
                    </span>
                  </div>
                </template>
              </el-table>
            </ItemsListSortable>
          </ItemsManagementWrapper>
        </el-tab-pane>
        <!-- 規格列表 -->
        <el-tab-pane
          :label="$t('OrderFoodItemManagement.SpecManagement')"
          name="spec"
        >
          <ItemsManagementWrapper
            ref="specManagementWrapperRef"
            :title="$t('OrderFoodItemManagement.SpecList')"
            :btn-text="$t('OrderFood.Spec')"
            @create="$router.push({ name: 'orderFoodSpecEdit', params: { id: '0' } })"
            @sort-active="(val) => handleSortActive('spec', val)"
            @save-order="handleSaveOrder('spec')"
          >
            <ItemsListSortable ref="specListSortableRef" class="order-food-item-management__sortable" @drag-end="(val) => handleDragEnd('spec', val)">
              <el-table ref="specTableRef" :data="specList" row-key="id" :tree-props="{children: 'unset'}">
                <el-table-column label="#" :width="specTableColumnSetting[0].width" align="center">
                  <template slot-scope="scope">
                    <TableDragBtn :is-sorting="isSpecTableSortable" :handler-class="'drag-handle'" :index="scope.$index" />
                  </template>
                </el-table-column>
                <el-table-column v-if="!isSpecTableSortable" width="1" type="expand">
                  <template slot-scope="scope">
                    <div v-for="(item, index) in scope.row.children" :key="`id${scope.row.id}_${index}`" class="order-food-item-management__expand-item" :style="{'padding-left': specTableExpandColumnPaddingLeft + 'px'}">
                      <span>{{ item.name }}</span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('OrderFood.Spec')" :width="specTableColumnSetting[1].width" label-class-name="order-food-item-management__expand-column-title">
                  <template slot-scope="scope">
                    <TableExpandBtn :name="scope.row.name" :is-expand="scope.row.isExpand" :disabled="scope.row.children.length <= 0 || isSpecTableSortable" @icon-click="handleRowExpand('spec', scope.row)" />
                  </template>
                </el-table-column>
                <el-table-column :label="$t('OrderFood.SpecOptions')">
                </el-table-column>
                <el-table-column :label="$t('OrderFoodItemManagement.Action')" :width="specTableColumnSetting[3].width">
                  <template slot-scope="scope">
                    <el-button
                      type="primary"
                      plain
                      size="mini"
                      :disabled="isSpecTableSortable"
                      @click="$router.push({ name: 'orderFoodSpecEdit', params: { id: scope.row.id } })"
                    >
                      {{ $t('OrderFoodItemManagement.Edit') }}
                    </el-button>
                  </template>
                </el-table-column>
                <template slot="empty">
                  <div class="order-food-item-management__empty-container">
                    <span class="order-food-item-management__empty-text">
                      {{ $t('OrderFoodItemManagement.HaveNotCreatedAnySpec') }}
                    </span>
                    <span class="order-food-item-management__empty-text">
                      {{ $t('OrderFoodItemManagement.SpecTableCreateTip1') }}
                    </span>
                    <span class="order-food-item-management__empty-text">
                      {{ $t('OrderFoodItemManagement.SpecTableCreateTip2') }}
                    </span>
                  </div>
                </template>
              </el-table>
            </ItemsListSortable>
          </ItemsManagementWrapper>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ItemsManagementWrapper from './components/ItemsManagementWrapper.vue'
import ItemsListSortable from './components/ItemsListSortable.vue'
import TableDragBtn from './components/TableDragBtn.vue'
import TableExpandBtn from './components/TableExpandBtn.vue'
import { apiOrderFood } from '@/api/OrderFood'
import { convertKeysToPascalCase, convertKeysToCamelCase, toUpperCamelCase } from '@/js/utils/bff'
export default {
  name: 'OrderFoodItemManagement',
  components: {
    ItemsManagementWrapper,
    ItemsListSortable,
    TableDragBtn,
    TableExpandBtn
  },
  data () {
    return {
      activeTab: 'menu', // 目前選擇的 Tab
      menuManagementWrapperRef: null, // 類別管理實例
      menuListSortableRef: null, // 類別排序實例
      menuTableRef: null, // 類別表格實例
      isMenuTableSortable: false, // 類別表格是否排序啟用
      // 類別表格欄位寬度
      menuTableColumnSetting: [
        {
          title: '#',
          width: 60
        },
        {
          title: this.$t('OrderFood.FoodCategory'),
          width: 160
        },
        {
          title: this.$t('OrderFood.FoodItem'),
          width: 200,
          expandItemStyle: {
            width: 200 + 'px'
          }
        },
        {
          title: this.$t('OrderFoodItemManagement.Status'),
          width: 80,
          expandItemStyle: {
            width: 80 + 'px'
          }
        },
        {
          title: this.$t('OrderFood.NormalPoints'),
          width: 120,
          expandItemStyle: {
            width: 120 + 'px'
          }
        },
        {
          title: this.$t('OrderFood.CashPoints'),
          width: 120,
          expandItemStyle: {
            width: 120 + 'px'
          }
        },
        {
          title: this.$t('OrderFood.SpecOptions'),
          width: '',
          expandItemStyle: {
            width: 200 + 'px',
            lineHeight: 'initial'
          }
        },
        {
          title: this.$t('OrderFoodItemManagement.Action'),
          width: 200
        }
      ],
      specManagementWrapperRef: null, // 規格管理實例
      specListSortableRef: null, // 規格排序實例
      specTableRef: null, // 規格表格實例
      isSpecTableSortable: false, // 規格表格是否排序啟用
      // 規格表格欄位寬度
      specTableColumnSetting: [
        {
          title: '#',
          width: 60
        },
        {
          title: this.$t('OrderFood.Spec'),
          width: 200
        },
        {
          title: this.$t('OrderFood.SpecOptions'),
          width: ''
        },
        {
          title: this.$t('OrderFoodItemManagement.Action'),
          width: 200
        }
      ],
      isListSorted: false // 列表是否排序
    }
  },
  computed: {
    ...mapState({
      menuList: state => state.orderFood.menuList,
      specList: state => state.orderFood.specList
    }),
    // 類別表格展開欄位左側間距
    menuTableExpandColumnPaddingLeft () {
      return this.menuTableColumnSetting[0].width + this.menuTableColumnSetting[1].width + 10
    },
    // 規格表格展開欄位左側間距
    specTableExpandColumnPaddingLeft () {
      return this.specTableColumnSetting[0].width + this.specTableColumnSetting[1].width + 10
    }
  },
  created () {
    // 若從編輯頁返回時切換至對應頁籤，否則預設為「類別管理」頁籤
    this.activeTab = this.$route.meta.fromPage === 'orderFoodSpecEdit' ? 'spec' : 'menu'
  },
  async mounted () {
    this.$loading({
      lock: true,
      text: this.$t('General.PleaseWaitFor', { action: this.$t('OrderFood.InitializingData') }),
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.7)'
    })
    try {
      await Promise.all([
        this.$store.dispatch('getFoodMenu'),
        this.$store.dispatch('getFoodSpec')
      ])
    } catch (error) {
      console.log(error)
      this.$message({
        message: this.$t('OrderFood.InitializingData') + this.$t('General.Fail'),
        type: 'error'
      })
    } finally {
      this.$loading().close()
    }

    this.$nextTick(() => {
      this.setSpecColumnWidth()
    })
  },
  methods: {
    /**
     * 處理排序啟用狀態
     * @param {menu | spec} target 目標
     * @param {boolean} val 狀態
     */
    handleSortActive (target, val) {
      this[`is${toUpperCamelCase(target)}TableSortable`] = val
      if (val) {
        this.$refs[`${target}ListSortableRef`].init()
        // 關閉所有展開行
        this[`${target}List`].forEach((row) => {
          this.$refs[`${target}TableRef`].toggleRowExpansion(row, false)
          this.$store.commit(`update${toUpperCamelCase(target)}ItemExpand`, { id: row.id, status: false })
        })
        this.$refs[`${target}TableRef`].doLayout()
      } else {
        this.$refs[`${target}ListSortableRef`].destroy()
        if (this.isListSorted) {
          this.handleRefreshTargetList(target)
        }
        this.resetSortStatus(target)
      }
    },
    /**
     * 處理拖曳結束
     * @param {menu | spec} target 目標
     * @param {object} evt
     */
    handleDragEnd (target, { oldIndex, newIndex }) {
      if (oldIndex === newIndex) {
        return
      }

      this.isListSorted = true
      if (target === 'menu') {
        this.$store.commit('updateMenuListOrder', { oldIndex, newIndex })
      } else if (target === 'spec') {
        this.$store.commit('updateSpecListOrder', { oldIndex, newIndex })
      }
    },
    /**
     * 處理儲存排序
     * @param {menu | spec} target 目標
     */
    async handleSaveOrder (target) {
      const loading = this.$loading({
        lock: true,
        text: this.$t('General.PleaseWaitFor', { action: this.$t('OrderFoodItemManagement.UpdateSequence') }),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      let isSuccessful = false
      try {
        const params = {
          sequences: [...this[`${target}List`].map((item, index) => {
            return {
              id: item.id,
              sequence: index + 1
            }
          })]
        }
        let checkStats = 0
        if (target === 'menu') {
          const { status } = convertKeysToCamelCase((await apiOrderFood.updateFoodMenuSequence(convertKeysToPascalCase(params))).data)
          checkStats = status
        } else if (target === 'spec') {
          const { status } = convertKeysToCamelCase((await apiOrderFood.updateFoodSpecSequence(convertKeysToPascalCase(params))).data)
          checkStats = status
        }
        if (checkStats === 1) {
          isSuccessful = true
          this.resetSortStatus(target)
          this.$message({
            message: this.$t('OrderFoodItemManagement.SequenceUpdated'),
            type: 'success'
          })
          // 重新讀取對應資料
          this.handleRefreshTargetList(target)
        }
      } catch (error) {
        console.log(error)
      } finally {
        if (!isSuccessful) {
          this.$message({
            message: this.$t('OrderFoodItemManagement.UpdateSequence') + this.$t('General.Fail'),
            type: 'error'
          })
        }
        loading.close()
      }
    },
    /**
     * 處理刷新目標列表資料
     * @param {menu | spec} target 目標
     */
    handleRefreshTargetList (target) {
      // 重新讀取對應資料
      if (target === 'menu') {
        this.$store.dispatch('getFoodMenu')
      } else if (target === 'spec') {
        this.$store.dispatch('getFoodSpec')
      }
    },
    /**
     * 重置排序狀態
     * @param {menu | spec} target 目標
     */
    resetSortStatus (target) {
      this.isListSorted = false
      if (target === 'menu') {
        this.$refs.menuManagementWrapperRef.setSortActive(false)
      } else if (target === 'spec') {
        this.$refs.specManagementWrapperRef.setSortActive(false)
      }
    },
    /**
     * 處理離開 Tab 之前
     * @param {string} newTabName 要前往的頁籤名稱
     * @param {string} oldTabName 原本所在頁籤名稱
     */
    handleBeforeLeaveTab (newTabName, oldTabName) {
      return new Promise((resolve, reject) => {
        if (this.isListSorted) {
          this.$alert(this.$t('OrderFoodItemManagement.IfLeaveChangeNotSaved'), this.$t('OrderFoodItemManagement.NotSavedYet'), {
            showClose: false,
            showCancelButton: true,
            cancelButtonText: this.$t('OrderFoodItemManagement.KeepSequencing'),
            confirmButtonText: this.$t('General.Leave'),
            confirmButtonClass: 'el-button--danger',
            callback: action => {
              // 若點擊「繼續排序」則不離開
              if (action === 'cancel') {
                reject(new Error('使用者取消離開'))
              } else {
                this.resetSortStatus(oldTabName)
                this.handleRefreshTargetList(oldTabName)
                resolve()
              }
            }
          })
        } else {
          this.resetSortStatus(oldTabName)
          resolve()
        }
      })
    },
    /**
     * 處理展開行
     * @param {menu | spec} target 目標
     * @param {object} row 資料列
     */
    handleRowExpand (target, row) {
      this.$store.commit(`update${toUpperCamelCase(target)}ItemExpand`, { id: row.id, status: !row.isExpand })
      this.$refs[`${target}TableRef`].toggleRowExpansion(row, row.isExpand)
    },
    /**
     * 取得規格欄位寬度
     */
    setSpecColumnWidth () {
      try {
        const columnWidth = document.querySelector('.el-table_1_column_8').clientWidth || 200
        this.menuTableColumnSetting[6].expandItemStyle.width = (columnWidth - 12) + 'px'
      } catch (error) {
        console
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.order-food-item-management {
  @include mainLayer();
  .el-tabs {
    @include basicTabs();
  }
  .footer-container {
    padding-top: 20px;
  }
  &__drag-btn {
    ::v-deep .el-button {
      width: 32px;
      height: 32px;
      cursor: move;
    }
    ::v-deep .el-button i {
      padding: 0;
    }
  }
  &__empty-container {
    display: flex;
    flex-direction: column;
    color: #a6a6a6;
    font-size: map-get($fontSize, medium);
    padding: 16px 0;
  }
  &__empty-text {
    &:not(:last-child) {
      margin-bottom: 10px;
    }
  }
  &__expand-item {
    display: flex;
    align-items: center;
    min-height: 50px;
    &:not(:last-child)   {
      border-bottom: 1px solid $borderDark1;
    }
    &--disabled {
      color: $lightFontColor;
    }
  }
  ::v-deep .el-table__expand-icon {
    display: none;
  }
  ::v-deep &__expand-column-title {
    padding-left: 19px !important;
  }
}
</style>
